import React, { useState } from "react";
import "./Header.css";
import logo from "../../assets/images/logo.png";
import { ReactComponent as MenuIcon } from "../../assets/svgs/MenuIcon.svg";
import { Link } from "react-router-dom";
import { navigateHandler } from "../../helpers";
import { motion } from "framer-motion";
import {
  AppBar,
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Toolbar,
} from "@mui/material";
import { navigateTo } from "../../helpers/navigateHandler";

const drawerWidth = 240;
const navItems = [
  { title: "Home", url: "/" },
  { title: "About", url: "/#about" },
  { title: "Interests", url: "/#interests" },
  { title: "Skills", url: "/#skills" },
  { title: "Portfolio", url: "/#portfolio" },
  { title: "Contact", url: "/#contact" },
];

const Header = (props) => {
  const { window } = props;
  const [showNav, setShowNav] = useState(false);

  const setNav = () => setShowNav(!showNav);

  const drawer = (
    <Box onClick={setNav} sx={{ textAlign: "center" }}>
      <Box sx={{ my: 1 }}>
        <img width="80rem" src={logo} alt="Michael Quarcoo" />
      </Box>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item.title} disablePadding>
            <ListItemButton
              sx={{ textAlign: "center" }}
              onClick={() => navigateTo(item.url)}
            >
              <ListItemText primary={item.title} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      transition={{ delay: 12, duration: 2 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
    >
      <AppBar
        component="nav"
        sx={{
          backgroundColor: "unset",
          position: "unset",
          minHeight: "unset",
          justifyContent: "center",
          height: "100%",
          boxShadow: "none",
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            minHeight: "unset !important",
          }}
        >
          <img className="logo" src={logo} alt="Michael Quarcoo" />
          <IconButton
            sx={{
              display: {
                xs: "flex",
                md: "none",
                justifyContent: "center",
                alignItems: "center",
              },
            }}
            onClick={setNav}
          >
            <MenuIcon className="menu" />
          </IconButton>
          <Box
            sx={{
              display: {
                xs: "none",
                md: "flex",
                justifyContent: "space-around",
                width: "30rem",
              },
            }}
          >
            {navItems.map((item) => (
              <Link key={item.url} to={item.url} onClick={navigateHandler}>
                {item.title}
              </Link>
            ))}
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          variant="temporary"
          open={showNav}
          container={container}
          onClose={setNav}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </motion.header>
  );
};

export default Header;
